import { gql } from '@apollo/client';

const RMA_LIMIT_CONFIG_QUERY = gql`
  query rmaLimitConfig {
    rmaLimitConfig {
      maxDevicePerTicket
    }
  }
`;

export default RMA_LIMIT_CONFIG_QUERY;
